export const areObjsEqual = (obj1: any, obj2: any) => {
  const keysEqual =
    Object.keys(obj1).toString() === Object.keys(obj2).toString();
  const valsEqual =
    Object.values(obj1).toString() === Object.values(obj2).toString();
  return keysEqual && valsEqual;
};

export function pickAttributes<T extends object, K extends keyof T>(
  obj: T,
  attributes: K[]
): Pick<T, K> {
  const result: Partial<Pick<T, K>> = {};

  for (const attribute of attributes) {
    if (attribute in obj) {
      result[attribute] = obj[attribute];
    }
  }

  return result as Pick<T, K>;
}

export function merge<T>(...objects: T[]): T {
  return Object.assign({}, ...objects);
}

/** Converts an object into query parameters */
export function objectToQueryParams(obj?: any): string {
  if (!obj) {
    return '';
  }

  return Object.keys(obj)
    .filter((key) => obj[key] !== undefined)
    .map((key) => `${key}=${obj[key]}`)
    .join('&');
}
